import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'pl-PL',
    messages: {
        'en-US': {
            wallets: 'Wallets',
            setting: 'Settings',
            home: 'Home',
            wishlist: 'Wishlist'
        },
        'pl-PL': {
            wallets: 'Portfele',
            setting: 'Opcje',
            home: 'Dom',
            wishlist: 'Lista życzeń'
        }
    }
});

export default i18n;